import React from 'react';
import { useSlotPlaceholder } from './hooks/useSlotPlaceholder';
export const SlotsPlaceholder = (props) => {
    const [Placeholder] = useSlotPlaceholder(props.slotId);
    return React.createElement(Placeholder, null);
};
//# sourceMappingURL=slotsPlaceholder.js.map